module.exports = __webpack_public_path__ + "static/media/(H)-Prata-04.4f553e56.jpg";